import {Component, OnDestroy, OnInit} from '@angular/core';
import {Configuration} from "@shared/models/configuration";
import {CellEditorComponentBase} from "@shared/components/cell-components/cell-component";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import {DialogService} from "@shared/services/dialog-service";
import {
  UpdateDac6AssociateEnterpriseCommand
} from "../../commands/dac6-reporter.command";
import {CommandService} from "@core/services/command.service";
import {UpdateDataSurveyAssociateEnterpriseCommand} from "../../../data-survey/commands/survey.commands";
import {ParticleState} from "@shared/store/reducers/particle.reduer";
import {select, Store} from "@ngrx/store";
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {QueryProvider} from "@shared/queries/query-provider";
import {getQueryResponse} from "@shared/store/selectors/query.selector";
import {skip, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";

@Component({
    standalone: false,
    selector: 'particle-associate-enterprise-cell-editor',
  templateUrl: './associate-enterprise-cell-editor.component.html',
  styleUrls: ['./associate-enterprise-cell-editor.component.scss']
})
export class AssociateEnterpriseCellEditorComponent extends CellEditorComponentBase implements OnInit, OnDestroy {

  //sourceType = 'Arrangement-Associate-Enterprises-Config';
  invalidateSubject: InvalidateSubject;
  sourceConfigKey: string;
  ngUnsubscribe$ = new Subject<void>();
  private displayTextConfig: string;
  constructor(private dialogService: DialogService,
              protected particleStore: Store<ParticleState>,
              protected fuseSplashScreenService: FuseSplashScreenService,
              private commandService: CommandService) {
    super();
    this.invalidateSubject = new InvalidateSubject();
  }

  ngOnInit() {
    const config = Configuration.getSmartGridConfig(this.fieldDefinition.configKey);
    if (config.DisplayTextConfig) {
      this.displayTextConfig = config.DisplayTextConfig;
    }
    const application = config.SourceType.split('-')[0];
    if(application === 'DataSurvey'){
      config.Parameters['ID'] = this.item.id;
    }
  }
  onGridCellValueChange(event) {
    if (event.action) {
      switch (event.action.id) {
        case 'Edit':
          this.edit(event);
          break;
      }
      return;
    }
    console.log(event);
  }
  edit(event: any) {
    this.openEditor(event);
  }
  public openEditor(event: any) {
    let minWidth = '1200';
    const maxWidth = '1500px';

    const editorConfig = Configuration.getSmartGridConfig(event.fieldDefinition.configKey);
    const leftConfigKey = editorConfig.LeftConfig;
    const leftConfig = Configuration.getSmartGridConfig(leftConfigKey);
    leftConfig.Parameters['CASE_ID'] = event.item.id;
    leftConfig.Parameters['ITEM_ID'] = event.item.id;

    const rightConfigKey = editorConfig.RightConfig;
    const rightConfig = Configuration.getSmartGridConfig(rightConfigKey);
    rightConfig.Parameters['CASE_ID'] = event.item.id;
    rightConfig.Parameters['ITEM_ID'] = event.item.id;

    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, minWidth, maxWidth, this.sourceType).subscribe(state => {
      console.log('After Edit', state);
      if (state.action === 'OK') {
        const command = this.getCommand(event);
        if(command === null)return;
        this.commandService.executeCommand(command).subscribe(commandState=>{
          if(commandState){
            this.invalidateSubject.invalidate();
            this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition});
          }
        });
      }
    });
  }

  private getCommand(event) {
    const appID = this.fieldDefinition.configKey.split('-')[0];
    if(appID === 'DAC6'){
      return new UpdateDac6AssociateEnterpriseCommand(event.item.id, event.item.cells[event.fieldDefinition.key].value, this.item.id);
    }
    else if(appID === 'DataSurvey'){
      return new UpdateDataSurveyAssociateEnterpriseCommand(this.item.id, event.item.cells['ItemId'].value, event.item.id, event.item.cells[event.fieldDefinition.key].value);
    }
    return null;
  }
  async onClicked() {
    let promise;
    if (this.displayTextConfig) {
      promise = new Promise((resolve, reject) => {
        this.fuseSplashScreenService.show();
        QueryProvider.invokeQueryByExecutionId(this.particleStore, this.displayTextConfig, this.item.id, {'[ID]': this.item.id});
        this.particleStore.pipe(select(getQueryResponse, this.item.id),skip(1), takeUntil(this.ngUnsubscribe$)).subscribe(res => {
          if (typeof res === 'string') {
            resolve(res);
          }
        });
      });
      await promise.then(res => {
        this.fuseSplashScreenService.hide();
        this.item.cells[this.fieldDefinition.key].displayText = res;
        return true;
      });
    } else {
      return true;
    }
  }
  ngOnDestroy(){
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
